import { isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18131: фича включает редактирование документов внутри паблик-папок с правами на редактирование.
export const editDocumentInPublic = isFeature('edit-document-in-public');
